<template>
  <div class="bus-aduit">
    <div class="btn-content">
      <el-radio-group v-model="tabIndex" @change="getTableList()">
        <el-radio-button :label="item.value" v-for="(item, index) in tabData" :key="index">{{ item.name }}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="container">
      <el-collapse v-if="tableList.length" v-model="activeName" accordion>
        <el-collapse-item :title="item.workflowName" v-for="(item, index) in tableList" :key="index" :name="index">
          <div class="bar">
            <process-bar :data="item.workflowNodes"></process-bar>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div v-else class="empty-tips">
        <span>{{ $t('Common.com_no_data') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import processBar from './process_bar';

export default {
  name: '',
  mixins: [],
  components: {
    processBar
  },
  props: {
    roleId: [String, Number],
    orgId: [String, Number]
  },
  data() {
    return {
      dicMap: {},
      tabIndex: '',
      tabData: [],
      tableList: [],
      activeName: 0
    };
  },
  watch: {
    roleId(val) {
      if (val && this.tabIndex) {
        this.getTableList(true);
      }
    }
  },
  methods: {
    // 字典列表转为map{code, value}
    dicListToMap(list) {
      const map = {};
      list.forEach((item) => {
        map[item.code] = item.value;
      });
      return map;
    },
    getTableList(init) {
      if (init) {
        this.tabIndex = this.tabData[0].value;
      }
      // RoleWorkflowList
      const reqData = {
        workflowClass: this.tabIndex,
        roleId: this.roleId,
        orgId: this.orgId
      };
      this.$getJSON(apis.RoleWorkflowList, reqData).then((res) => {
        this.tableList = res.data;
      });
    }
  },
  mounted() {
    this.getDictionary('workflow_class', (data) => {
      this.tabIndex = data.workflow_class[0].value;
      this.tabData = data.workflow_class;
      this.dicMap.workflow_class = this.dicListToMap(data.workflow_class);
      this.getTableList();
    });
  }
};
</script>

<style lang="scss" scoped>
.bus-aduit {
  flex: 1;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .btn-content {
    height: 44px;
  }

  .container {
    flex: 1;
    overflow-y: auto;

    .empty-tips {
      text-align: center;
      display: flex;
      height: 100%;
      color: #909399;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }
  }
}
</style>
